/// <reference types="node" />
export var CLIENT_VERSION = "5.0.0";